import { DataBean } from "../DataBean";

export class AddProductToMarketPlace extends DataBean {


    public async addProductToMarketPlace(idProduct: any, idMarketPlace: any, idMarketPlaceCategory: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.inventory.MarketPlaceProduct_addProductToMarketPlace_Number_Number_Number", [idProduct, idMarketPlace, idMarketPlaceCategory]);
    }

}